import {AfterViewInit, Directive, ElementRef, HostListener, Input, OnInit, Renderer2} from '@angular/core';
import { RippleConfig } from './ripple.models';
export class CbjRippleDirective implements OnInit, AfterViewInit {
  cbjRipple: RippleConfig;
  config: RippleConfig;
  rippleContainer: HTMLElement;
  animating: boolean;
/**
 * @param {?} el
 * @param {?} renderer
 */
constructor(private el: ElementRef,
private renderer: Renderer2) { }
/**
 * @param {?} e
 * @return {?}
 */
onTouchStart(e: Event) {
    this.rippleStart(e);
  }
/**
 * @param {?} e
 * @return {?}
 */
onMouseDown(e: MouseEvent) {
    this.rippleStart(e);
  }
/**
 * @param {?} e
 * @return {?}
 */
onMouseLeave(e: MouseEvent) {
    this.rippleEnd(e);
  }
/**
 * @param {?} e
 * @return {?}
 */
onTransitionEnd(e: MouseEvent) {
    this.rippleEnd(e);
  }
/**
 * @return {?}
 */
ngOnInit() {
    const /** @type {?} */ defaults: RippleConfig = {
      cxlOnMove: true,
      color: 'white',
      opacity: 0.25,
      shadow: 'none',
      expandTime: .25,
      size: null
    };
    this.config = {
      ...defaults,
      ...this.cbjRipple,
    };
    this.animating = false;
  }
/**
 * @return {?}
 */
ngAfterViewInit() {
    this.setInitStyles();
    this.createContainer();
  }
/**
 * @return {?}
 */
private setInitStyles() {
    this.renderer.setStyle(this.el.nativeElement, 'overflow', 'hidden');
    this.renderer.setStyle(this.el.nativeElement, 'position', 'relative');
    this.renderer.addClass(this.el.nativeElement, 'cbj-ripple');
  }
/**
 * @return {?}
 */
private createContainer() {
    const /** @type {?} */ size = this.config.size ? this.config.size : Math.max(this.el.nativeElement.offsetHeight, this.el.nativeElement.offsetWidth);

    this.rippleContainer = this.renderer.createElement('div');
    this.renderer.setStyle(this.rippleContainer, 'transition', `transform ${this.config.expandTime}s cubic-bezier(.17,.67,.83,.67)`);
    this.renderer.setStyle(this.rippleContainer, 'height', `${size}px`);
    this.renderer.setStyle(this.rippleContainer, 'width', `${size}px`);
    this.renderer.setStyle(this.rippleContainer, 'display', 'block');
    this.renderer.setStyle(this.rippleContainer, 'border-radius', '100%');
    this.renderer.setStyle(this.rippleContainer, 'position', 'absolute');
    this.renderer.setStyle(this.rippleContainer, 'transform', 'scale(0)');
    this.renderer.setStyle(this.rippleContainer, 'background-color', this.config.color);
    this.renderer.appendChild(this.el.nativeElement, this.rippleContainer);
  }
/**
 * @param {?} e
 * @return {?}
 */
private rippleStart(e: MouseEvent | TouchEvent | any) {
    if (!this.animating) {
      this.animating = true;
      const /** @type {?} */ size = this.config.size ? this.config.size : Math.max(this.el.nativeElement.offsetWidth, this.el.nativeElement.offsetHeight);
      let /** @type {?} */ pageX;
      let /** @type {?} */ pageY;
      if (e instanceof MouseEvent) {
        pageX = e.offsetX;
        pageY = e.offsetY;
      }else {
        pageX = e.touches[0].clientX;
        pageY = e.touches[0].clientY;
      }
      const /** @type {?} */ x = pageX -  size / 2;
      const /** @type {?} */ y = pageY - size / 2;


      this.renderer.setStyle(this.rippleContainer, 'top', `${y}px`);
      this.renderer.setStyle(this.rippleContainer, 'left', `${x}px`);
      this.renderer.setStyle(this.rippleContainer, 'opacity', this.config.opacity);
      this.renderer.setStyle(this.rippleContainer, 'background-color', this.config.color);
      this.renderer.setStyle(this.rippleContainer, 'boxShadow', this.config.shadow);
      this.renderer.setStyle(this.rippleContainer, 'transform', `scale(2.5)`);
    }
  }
/**
 * @param {?} e
 * @return {?}
 */
private rippleEnd(e: MouseEvent | TouchEvent) {
    if (this.animating) {
      this.animating = false;
      this.renderer.setStyle(this.rippleContainer, 'boxShadow', 'none');
      this.renderer.setStyle(this.rippleContainer, 'transform', `scale(0)`);
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[cbjRipple]'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Renderer2, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'cbjRipple': [{ type: Input, args: ['cbjRipple', ] },],
'onTouchStart': [{ type: HostListener, args: ['touchstart', ['$event'], ] },],
'onMouseDown': [{ type: HostListener, args: ['click', ['$event'], ] },],
'onMouseLeave': [{ type: HostListener, args: ['mouseleave', ['$event'], ] },],
'onTransitionEnd': [{ type: HostListener, args: ['transitionend', ['$event'], ] },],
};
}

function CbjRippleDirective_tsickle_Closure_declarations() {
/** @type {?} */
CbjRippleDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CbjRippleDirective.ctorParameters;
/** @type {?} */
CbjRippleDirective.propDecorators;
/** @type {?} */
CbjRippleDirective.prototype.cbjRipple;
/** @type {?} */
CbjRippleDirective.prototype.config;
/** @type {?} */
CbjRippleDirective.prototype.rippleContainer;
/** @type {?} */
CbjRippleDirective.prototype.animating;
/** @type {?} */
CbjRippleDirective.prototype.el;
/** @type {?} */
CbjRippleDirective.prototype.renderer;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
